import Axios from "axios"

export default {

  /**
   * 客户搜索参数
   */
  customerParamInfo() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/log/recognition/projectCustomer/box/searchField`);
  },

  /**
   * 客户日志
   * @param {*} open_id 
   * @param {*} project_attr_name 
   * @param {*} location_name 
   * @param {*} recognition_start_time 
   * @param {*} recognition_end_time 
   * @param {*} page 
   */
  customerLog(
    open_id,
    project_attr_name,
    location_name,
    recognition_start_time,
    recognition_end_time,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/log/recognition/projectCustomer/box/page`, {
      params: {
        open_id,
        project_attr_name,
        location_name,
        recognition_start_time,
        recognition_end_time,
        page
      }
    });
  },

  /**
   * 员工搜索参数
   */
  staffParamInfo() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/log/recognition/user/box/searchField`);
  },

  /**
   * 员工日志
   * @param {*} open_id 
   * @param {*} project_attr_name 
   * @param {*} location_name 
   * @param {*} recognition_start_time 
   * @param {*} recognition_end_time 
   * @param {*} page 
   */
  staffLog(
    user_name,
    project_attr_name,
    location_name,
    recognition_start_time,
    recognition_end_time,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/log/recognition/user/box/page`, {
      params: {
        user_name,
        project_attr_name,
        location_name,
        recognition_start_time,
        recognition_end_time,
        page
      }
    });
  },

  /**
   * 外部员工日志
   * @param {*} open_id 
   * @param {*} project_attr_name 
   * @param {*} location_name 
   * @param {*} recognition_start_time 
   * @param {*} recognition_end_time 
   * @param {*} page 
   */
  extraStaffLog(
    open_id,
    project_attr_name,
    location_name,
    recognition_start_time,
    recognition_end_time,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/log/recognition/projectCustomer/box/externalStaffPage`, {
      params: {
        open_id,
        project_attr_name,
        location_name,
        recognition_start_time,
        recognition_end_time,
        page
      }
    });
  },

}